export function paginationPages(index: number, limits: {min: number, max: number}): string {
  if (limits.min <= index && index < limits.max) {
    if ((index + 1) % 2 !== 0) {
      return 'odd'
    } else {
      return 'even'
    }
  } else {
    return 'd-none'
  }
}